import { render } from "./ImageView.vue?vue&type=template&id=51979a82&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"

import "./ImageView.vue?vue&type=style&index=0&id=51979a82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51979a82"]])

export default __exports__